var _rect, _rect2, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFbIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78711 36.975V13H22.6621V16.395H11.6721V24.48H20.8071V27.875H11.6721V36.975H7.78711Z",
    fill: "#0940C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 13H34.4125C36.8625 13 38.6942 13.5016 39.9075 14.505C41.1208 15.485 41.7275 17.06 41.7275 19.23C41.7275 20.6533 41.4942 21.7733 41.0275 22.59C40.5842 23.4066 39.8725 24.0833 38.8925 24.62C41.1792 25.5066 42.3225 27.3616 42.3225 30.185C42.3225 34.7116 39.7792 36.975 34.6925 36.975H25.3125V13ZM34.4125 26.51H29.1975V33.615H34.4825C35.7658 33.615 36.7225 33.3466 37.3525 32.81C38.0058 32.2733 38.3325 31.3516 38.3325 30.045C38.3325 28.7383 37.9592 27.8283 37.2125 27.315C36.4658 26.7783 35.5325 26.51 34.4125 26.51ZM34.2025 16.36H29.1975V23.22H34.3425C36.6292 23.22 37.7725 22.0416 37.7725 19.685C37.7725 17.4683 36.5825 16.36 34.2025 16.36Z",
    fill: "#0940C8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFbIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FB-Icon.34d8d7c6.svg";
export { ForwardRef as ReactComponent };